import Vue from 'vue'
import VueRouter from 'vue-router'
// import CanvasEditor from '../components/CanvasEditor.vue'
import DesignEditor from '../components/DesignEditor.vue'
import Profile from '../components/Profile.vue'
import Login from '../components/Login.vue'
import Register from '../components/Register.vue'
import About from '../components/About.vue'
import DesignList from '../components/DesignList.vue'
import Design from '../components/Design.vue'
import Home from '../components/Home.vue'
import PageNotFound from '../components/PageNotFound.vue'
import store from "../store";

Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next();
        return;
    }
    next("/");
};

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
        return;
    }
    next("/login");
};

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/editor/designs/:design_id',
        name: 'Editor',
        component: DesignEditor,
        props: {
            msg: "The Fancy Editor"
        },
        beforeEnter: ifAuthenticated
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/designs',
        name: 'My Designs',
        component: DesignList,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/designs/add',
        name: 'Add new design',
        component: Design,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        beforeEnter: ifNotAuthenticated
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        beforeEnter: ifNotAuthenticated
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        beforeEnter: ifAuthenticated
    },
    {
        path: '*',
        component: PageNotFound
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
